import { observable, action, reaction, makeObservable, computed } from 'mobx';

import RootStore from './RootStore';

const INIT_ZOOM_DATA = {
  offsetX: null,
  offsetY: null,
  zoom: null,
};

export default class MapBuilderStore {
  rootStore: typeof RootStore;
  @observable zoomData = { ...INIT_ZOOM_DATA };
  @observable selectedDevice = null;
  @observable selectedDeviceNode = null;
  @observable selectedDeviceTitle = null;
  @observable isDetailsModalMinimized = false;
  @observable activeTab = null;

  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;

    reaction(() => this.rootStore.stationStore.currentStation.id, this.reset);
  }

  @action setZoomData = zoomData => {
    this.zoomData.offsetX = zoomData.offsetX;
    this.zoomData.offsetY = zoomData.offsetY;
    this.zoomData.zoom = zoomData.zoom;
  };

  @action setSelectedDevice = device => {
    this.selectedDevice = device;
  };

  @action setSelectedDeviceTitle = title => {
    this.selectedDeviceTitle = title;
  };

  @action setActiveTab = tab => {
    this.activeTab = tab;
  };

  @action setIsDetailsModalMinimized = isMinimized => {
    this.isDetailsModalMinimized = isMinimized;
  };

  @action minimizeModal = () => {
    this.isDetailsModalMinimized = true;
  };

  @action maximizeModal = () => {
    this.isDetailsModalMinimized = false;
  };

  @action getDetailsModalVisibiltyByDeviceId = (deviceId, isMinimized) => {
    if (!this.selectedDevice) return false;
    if (this.selectedDevice.deviceId !== deviceId) return false;
    return !isMinimized;
  };

  @action getIsDeviceSelectedAndMinimizedByDeviceId = (deviceId, selectedDevice, isMinimized) => {
    if (selectedDevice?.deviceId !== deviceId) return false;
    return isMinimized;
  };

  @computed get isAnyDetailsModalOpen() {
    return this.selectedDevice?.deviceId && !this.isDetailsModalMinimized;
  }

  @action closeMaximizedModal = () => {
    if (this.isDetailsModalMinimized) {
      return;
    }

    this.selectedDevice = null;
    this.selectedDeviceNode = null;
    this.selectedDeviceTitle = null;
    this.activeTab = null;
  };

  @action closeMinimizedModal = () => {
    this.isDetailsModalMinimized = false;
    this.selectedDevice = null;
    this.selectedDeviceNode = null;
    this.selectedDeviceTitle = null;
    this.activeTab = null;
  };

  @action selectDeviceById = (deviceId, activeTab = null) => {
    const device = this.rootStore.stationStore.getDeviceById(deviceId);
    if (device) {
      this.setSelectedDevice(device);
      this.setSelectedDeviceTitle(device.deviceType);
      this.setActiveTab(activeTab);
      this.maximizeModal();
    }
  };

  @action reset = () => {
    this.zoomData = { ...INIT_ZOOM_DATA };
    this.isDetailsModalMinimized = false;
    this.selectedDevice = null;
    this.selectedDeviceNode = null;
    this.selectedDeviceTitle = null;
    this.activeTab = null;
  };
}
